/* eslint-disable no-eval */

export const isOptionalChainingSupported = () => {
  try {
    eval('const foo = {}; foo?.bar');
  } catch {
    return false;
  }

  return true;
};

export const isHandheldDevice = () => {
  // eslint-disable-next-line no-undef
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};
